module.exports = __webpack_public_path__ + "static/media/paserg-border-insignia.b7789f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-border-insignia.png
// module id = 213
// module chunks = 0